const HAIR_COLOR = ["Auburn", "Brown", "Blond", "Black", "Gray and white", "Red hair", "Other"];

export default HAIR_COLOR;
